import { useCallback, useEffect, useState } from "react";
import ReactFocusLock from "react-focus-lock";
import { TfaMethod } from "@/core/constants/tfaMethod";
import { ValidateCode } from "@/shared/ui";
import useChangePassword from "@/domains/playerMenu/hooks/useChangePassword";

type Props = {
  goToChangePassword: () => void;
};

export default function PlayerMenuSettingsSafetyChangePasswordAuthentificatorContainer({
  goToChangePassword,
}: Props) {
  const [authCode, setAuthCode] = useState("");
  const {
    checkCodeHandler,
    checkIsPending,
    checkError,
    checkIsCompleted,
    sendCodeHandler,
    sendIsPending,
  } = useChangePassword();

  const onSubmit = useCallback(async () => {
    checkCodeHandler(authCode);
  }, [authCode]);

  useEffect(() => {
    if (checkIsCompleted) {
      goToChangePassword();
    }
  }, [checkIsCompleted]);

  useEffect(() => {
    sendCodeHandler("", TfaMethod.AUTHENTICATOR);
  }, []);

  return (
    <ReactFocusLock className="grow flex flex-col w-full h-full">
      <ValidateCode
        onSubmit={onSubmit}
        type={TfaMethod.AUTHENTICATOR}
        address=""
        description="Введите 6-значный код из вашего приложения"
        onSendCode={() => {}}
        code={authCode}
        onCodeChange={setAuthCode}
        pending={checkIsPending || sendIsPending}
        sendCodePending={false}
        error={checkError}
      />
    </ReactFocusLock>
  );
}
